module.exports = __webpack_public_path__ + "assets/img/typeIcon-5-red.fb3193e5.svg";